import React from 'react';
import {
  TextField, NumberField, DateField, SelectField, TextAreaField,
  CheckboxField, MoneyField, PercentField, CnpjField,
} from '../fundo_liquido/fields';
import { Opt } from '../fundo_liquido/mock';
import { SecaoDef, CampoDef, campoVisivel } from './camposConfig';
import EmissorField from './EmissorField';

const CamposDinamicos: React.FC<{
  secoes: SecaoDef[];
  dados: Record<string, any>;
  prestadorOpts: Opt[];
  fundoOpts?: Opt[];
  erros?: Record<string, string>;
  onChange: (nome: string, valor: any) => void;
}> = ({ secoes, dados, prestadorOpts, fundoOpts = [], erros = {}, onChange }) => {
  const renderCampo = (c: CampoDef) => {
    const v = dados[c.nome];
    const set = (val: any) => onChange(c.nome, val);
    const comum = { label: c.label, required: c.obrigatorio, hint: c.hint, error: erros[c.nome], full: c.full };

    switch (c.tipo) {
      case 'number':
        return <NumberField {...comum} value={v ?? ''} onChange={set} />;
      case 'date':
        return <DateField {...comum} value={v ?? ''} onChange={set} />;
      case 'textarea':
        return <TextAreaField {...comum} value={v ?? ''} onChange={set} />;
      case 'money':
        return <MoneyField {...comum} value={v ?? ''} onChange={set} />;
      case 'percent':
        return <PercentField {...comum} value={v ?? ''} onChange={set} />;
      case 'checkbox':
        return <CheckboxField label={c.label} checked={!!v} onChange={set} />;
      case 'cnpj':
        return <CnpjField {...comum} value={v ?? ''} onChange={set} />;
      case 'select':
        return <SelectField {...comum} value={v ?? ''} onChange={set} options={c.opcoes ?? []} placeholder="Selecione..." />;
      case 'entidade':
        if (c.entidade === 'emissor') {
          return (
            <EmissorField
              label={c.label}
              required={c.obrigatorio}
              hint={c.hint}
              value={v ?? ''}
              onChange={(id) => set(id)}
            />
          );
        }
        return (
          <SelectField
            {...comum}
            value={v ?? ''}
            onChange={set}
            options={c.entidade === 'fundo' ? fundoOpts : prestadorOpts}
            placeholder="Selecione..."
          />
        );
      case 'text':
      default:
        return <TextField {...comum} value={v ?? ''} onChange={set} />;
    }
  };

  const renderSecao = (s: SecaoDef, comSubtitulo: boolean) => {
    const campos = s.campos.filter((c) => campoVisivel(c, dados));
    if (campos.length === 0) return null;
    const normais = campos.filter((c) => c.tipo !== 'checkbox');
    const flags = campos.filter((c) => c.tipo === 'checkbox');
    return (
      <div className="av-subsection" key={s.id}>
        {comSubtitulo && <h4 className="av-subsection-title">{s.titulo}</h4>}
        <div className="fl-grid">
          {normais.map((c) => <React.Fragment key={c.nome}>{renderCampo(c)}</React.Fragment>)}
        </div>
        {flags.length > 0 && (
          <div className="av-flags">
            {flags.map((c) => <React.Fragment key={c.nome}>{renderCampo(c)}</React.Fragment>)}
          </div>
        )}
      </div>
    );
  };

  const grupos: { destino: string; secoes: SecaoDef[] }[] = [];
  for (const s of secoes) {
    const g = grupos.find((x) => x.destino === s.destino);
    if (g) g.secoes.push(s); else grupos.push({ destino: s.destino, secoes: [s] });
  }

  return (
    <>
      {grupos.map((g) => {
        const multi = g.secoes.length > 1;
        const titulo = g.destino === 'renda_fixa' ? 'Renda Fixa' : g.secoes[0].titulo;
        return (
          <section className="av-card" key={g.destino}>
            <h3 className="av-card-title">{titulo}</h3>
            {g.secoes.map((s) => renderSecao(s, multi))}
          </section>
        );
      })}
    </>
  );
};

export default CamposDinamicos;
